import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 8.66667,
	height: 7.33333,
	viewBox: "0 0 8.66667 7.33333",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "arrow right small",
		d: "M1 3.66667H7.66667M5 6.33333L7.66667 3.66667L5 1",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowRightSmall;
